'use strict';

var framerMotion = require('framer-motion');
var React = require('react');
var _utils = require('./_utils.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const variants = {
    exit: (props) => ({
        opacity: 0,
        ...(props.reverse ? { scale: props.initialScale } : { transitionEnd: { scale: props.initialScale } }),
        transition: {
            duration: 0.2,
            ease: _utils.EASINGS.easeOut,
        },
    }),
    enter: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.25,
            ease: _utils.EASINGS.easeInOut,
        },
    },
};
const scaleFadeConfig = {
    variants,
    initial: 'exit',
    animate: 'enter',
    exit: 'exit',
};
const ScaleFade = React__namespace.forwardRef((props, ref) => {
    const { reverse = true, initialScale = 0.95, unmountOnExit, visible, ...rest } = props;
    const show = unmountOnExit ? visible && unmountOnExit : true;
    const custom = React__namespace.useMemo(() => ({ initialScale, reverse }), [initialScale, reverse]);
    const motionProps = React__namespace.useMemo(() => ({
        ...scaleFadeConfig,
        custom,
        animate: visible || unmountOnExit ? 'enter' : 'exit',
    }), [custom, visible, unmountOnExit]);
    return (React__namespace.createElement(framerMotion.AnimatePresence, { custom: custom }, show && React__namespace.createElement(framerMotion.motion.div, { ref: ref, ...motionProps, ...rest })));
});
ScaleFade.defaultProps = {
    initialScale: 0.95,
    reverse: true,
};
ScaleFade.displayName = 'ScaleFade';

exports.ScaleFade = ScaleFade;
exports.scaleFadeConfig = scaleFadeConfig;
//# sourceMappingURL=ScaleFade.js.map
